import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import { useSnackbar } from 'notistack';
import PaymentStatusForm from '../PaymentStatusForm';
import ContentDrawer from '@afosto/app-components-react/ContentDrawer';
import dateStringFromDate from '@afosto/utils/date/dateStringFromDate';
import { invoices as invoicesApi } from '@afosto/order/api/Invoices';
import translations from './translations';

const PaymentStatusDrawer = ({ invoice, isOpen, onChange, onClose }) => {
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();

  /**
   * Change the payment status of the invoice.
   * @param {boolean} isPaid
   * @param {Date} paidAt
   * @returns {Promise<void>}
   */
  const handleChangePaymentStatus = async ({ paidAt }) => {
    try {
      const paidAtValue = paidAt ? dateStringFromDate(new Date(paidAt)) : null;
      await invoicesApi.markPaid(invoice.id, {
        paid_at: paidAtValue,
      });

      if (onChange && typeof onChange === 'function') {
        await onChange(paidAtValue);
      }

      enqueueSnackbar(intl.formatMessage(translations.feedback.paymentStatusChanged), {
        variant: 'success',
      });
    } catch (err) {
      enqueueSnackbar(intl.formatMessage(translations.feedback.paymentStatusNotChanged), {
        variant: 'error',
      });
    }
  };

  return (
    <ContentDrawer
      title={intl.formatMessage(translations.title)}
      isOpen={isOpen}
      handleClose={onClose}
      drawerWidth="400px"
    >
      <PaymentStatusForm
        invoice={invoice}
        onCancel={onClose}
        onSubmit={handleChangePaymentStatus}
      />
    </ContentDrawer>
  );
};

PaymentStatusDrawer.propTypes = {
  invoice: PropTypes.object.isRequired,
  isOpen: PropTypes.bool,
  onChange: PropTypes.func,
  onClose: PropTypes.func,
};

PaymentStatusDrawer.defaultProps = {
  isOpen: false,
  onChange: undefined,
  onClose: undefined,
};

export default PaymentStatusDrawer;
